import { PageParams } from '../repositories/common/types/createOfflineCommonRepository.types';
import { offlineCustomersRepository } from '../repositories/offlineCustomers.repository';
import { OfflineCustomerTransformers } from '../transformers/OfflineDatabaseCustomer.transformers';
import { OfflinePaginatedParamsWithQuery } from './types/common.types';

const page = async ({ limit, skip, query }: OfflinePaginatedParamsWithQuery) => {
  const params: PageParams = query ? { limit, skip, query } : { limit, skip };
  const pageOfflineCustomers = await offlineCustomersRepository.page(params);
  const customers = pageOfflineCustomers.data.map(
    OfflineCustomerTransformers.toFindCustomersOutput,
  );
  return {
    data: customers,
    count: pageOfflineCustomers.count,
  };
};

export const customersRepositoryOfflineAdapters = {
  page,
};
